/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MoneyAmountWithRequiredTaxFromJSON, MoneyAmountWithRequiredTaxToJSON, } from './MoneyAmountWithRequiredTax';
/**
 * Check if a given object implements the PayNowContractTerm interface.
 */
export function instanceOfPayNowContractTerm(value) {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    return isInstance;
}
export function PayNowContractTermFromJSON(json) {
    return PayNowContractTermFromJSONTyped(json, false);
}
export function PayNowContractTermFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': MoneyAmountWithRequiredTaxFromJSON(json['amount']),
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}
export function PayNowContractTermToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': MoneyAmountWithRequiredTaxToJSON(value.amount),
        'id': value.id,
    };
}
